var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { registerPushToken, savePushData } from '@/ts/modules/appPushManager';
import ApiService from '../core/services/ApiService';
// 모바일 환경 체크용 유틸
window.isMobile = {
    Android: function () { return /Android|AOS|webview/i.test(navigator.userAgent); },
    iOS: function () { return /iPhone|iPad|iPod|iOS/i.test(navigator.userAgent); },
    any: function () {
        return this.Android() || this.iOS();
    },
};
/**
 * 앱 환경을 탐지하는 함수
 *
 * 이 함수는 현재 브라우저가 모바일 앱 환경인지 확인합니다.
 * - isApp: 모바일 앱 환경 여부
 * - isIosApp: iOS 앱 환경 여부
 * @returns { isApp: boolean, isIosApp: boolean }
 */
window.detectAppEnvironment = function () {
    var ua = navigator.userAgent.toLowerCase();
    var isApp = ua.includes('webview jobploy') || ua.includes('ios jobploy');
    var isIosApp = ua.includes('ios jobploy');
    return {
        isApp: isApp,
        isIosApp: isIosApp
    };
};
// 전역 함수들
// 앱 버전 요청
window.getVersion = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.getVersion) === null || _b === void 0 ? void 0 : _b.call(_a);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.getVersion) === null || _e === void 0 ? void 0 : _e.postMessage(null);
};
// 푸시 토큰 요청
window.getToken = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.getToken) === null || _b === void 0 ? void 0 : _b.call(_a);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.getToken) === null || _e === void 0 ? void 0 : _e.postMessage(null);
};
// 디바이스 UUID 요청
window.getUUID = function () {
    var _a, _b, _c, _d;
    if (window.isMobile.Android())
        (_a = window.webview) === null || _a === void 0 ? void 0 : _a.getUUID();
    else
        (_d = (_c = (_b = window.webkit) === null || _b === void 0 ? void 0 : _b.messageHandlers) === null || _c === void 0 ? void 0 : _c.getUUID) === null || _d === void 0 ? void 0 : _d.postMessage(null);
};
// 업데이트 알림 팝업 호출 요청
window.callUpdatePopup = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android()) {
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.callUpdatePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    else {
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.callUpdatePopup) === null || _e === void 0 ? void 0 : _e.postMessage(null);
    }
};
// 시스템 점검 팝업 호출 요청 (제목과 내용 전달)
window.callSystemCheckPopup = function () {
    var _a, _b, _c, _d, _e;
    var message = '제목, 내용';
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.callSystemCheckPopup) === null || _b === void 0 ? void 0 : _b.call(_a, message);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.callSystemCheckPopup) === null || _e === void 0 ? void 0 : _e.postMessage(message);
};
/**
 * 앱 열기 또는 앱스토어로 이동
 * 이 함수는 모바일 앱이 설치되어 있지 않은 경우 앱스토어로 이동하도록 합니다.
 * 앱이 설치되어 있으면 해당 앱을 열도록 합니다.
 *
 */
window.openAppOrInstall = function () {
    var currentUrl = window.location.href;
    if (window.isMobile.Android()) {
        // ✅ Android: Intent URI (앱 설치됨→앱 열기, 미설치→Play스토어 앱으로 바로 이동)
        var fallback = 'https://play.google.com/store/apps/details?id=kr.jobploy';
        var intentUri = "intent://open?url=".concat(encodeURIComponent(currentUrl), "#Intent;") +
            "scheme=jobploy;" +
            "package=kr.jobploy;" +
            "S.browser_fallback_url=".concat(encodeURIComponent(fallback), ";") +
            "end";
        location.href = intentUri;
        return;
    }
    if (window.isMobile.iOS()) {
        // ✅ iOS: 커스텀 스킴 + 짧은 타이머 fallback
        var schemeUrl = "jobploy://open?url=".concat(encodeURIComponent(currentUrl));
        var appStoreUrl_1 = 'https://apps.apple.com/app/jobploy/id6749568384';
        var now_1 = Date.now();
        location.href = schemeUrl;
        // 1.5초 이내에 앱이 열리지 않으면 앱스토어로 이동
        // 모바일 safari에서 앱&스토어앱 중복 호출 방지용
        setTimeout(function () {
            var elapsed = Date.now() - now_1;
            if (elapsed < 2000) {
                location.href = appStoreUrl_1;
            }
        }, 1500);
        return;
    }
};
window.redirectAppOrInstall = function () {
    var mainUrl = "".concat(location.origin, "/");
    if (window.isMobile.Android()) {
        var playStoreUrl = 'https://play.google.com/store/apps/details?id=kr.jobploy';
        location.replace(playStoreUrl);
        return;
    }
    if (window.isMobile.iOS()) {
        var appStoreUrl = 'https://apps.apple.com/app/jobploy/id6749568384';
        location.replace(appStoreUrl);
        return;
    }
    location.replace(mainUrl);
};
var bizServiceUrl = process.env.MIX_JOBPLOYEE_COMPANY_PAGE_HOST;
// 기업서비스 바로가기 링크 외부 브라우저로 열기
window.goBizService = function () {
    window.webview.startBrowser(bizServiceUrl);
};
window.goBizLoginService = function () {
    window.webview.startBrowser(bizServiceUrl + "/auth/login");
};
// 구글 로그인 요청
window.requestGoogleLogin = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.requestGoogleLogin) === null || _b === void 0 ? void 0 : _b.call(_a);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.requestGoogleLogin) === null || _e === void 0 ? void 0 : _e.postMessage(null);
};
// // 카카오 로그인 요청
window.requestKakaoLogin = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.requestKakaoLogin) === null || _b === void 0 ? void 0 : _b.call(_a);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.requestKakaoLogin) === null || _e === void 0 ? void 0 : _e.postMessage(null);
};
// 애플 로그인 요청
window.requestAppleLogin = function () {
    var _a, _b, _c, _d, _e;
    if (window.isMobile.Android())
        (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.requestAppleLogin) === null || _b === void 0 ? void 0 : _b.call(_a);
    else
        (_e = (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d.requestAppleLogin) === null || _e === void 0 ? void 0 : _e.postMessage(null);
};
// 앱에서 전달받은 버전 정보를 alert로 표시
window.responseVersion = function (version) {
    console.log('버전:', version);
    // alert('버전:' + version);
    savePushData({ version: version });
};
// 앱에서 전달받은 푸시 토큰을 alert로 표시
window.responseToken = function (token) {
    console.log('푸시 토큰:', token);
    // alert('푸시 토큰:' + token);
    savePushData({ token: token });
};
// 앱에서 전달받은 UUID를 저장
window.responseUUID = function (uuid) {
    console.log('UUID:', uuid);
    // alert('UUID:' + uuid);
    savePushData({ uuid: uuid });
};
window.pushTokenRegistTest = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    savePushData({
                        token: "asdf",
                        uuid: "uuid-1234-abcd-efga",
                        version: "1.2.3",
                    });
                    return [4 /*yield*/, registerPushToken()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
// 스토리지에 저장된 푸시 토큰을 강제로 등록하는 함수
window.forceRegistPushToken = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, registerPushToken()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
// 안드로이드용 공유 팝업 호출
window.openSharePopForAndroid = function (message) {
    var _a, _b;
    (_b = (_a = window.webview) === null || _a === void 0 ? void 0 : _a.openShare) === null || _b === void 0 ? void 0 : _b.call(_a, message);
};
//앱 스토어 오픈
window.openAppStore = function () {
    window.webview.startBrowser("https://play.google.com/store/apps/details?id=kr.jobploy");
};
//앱 종료
window.appExit = function () {
    window.webview.appExit();
};
//구글 로그아웃
window.logoutGoogle = function () {
    window.webview.logoutGoogle();
};
/**
 *
 * @param jsonString 로그인 응답 JSON 문자열
 *
 * 이 함수는 앱에서 소셜 로그인 후 호출한 토큰 검증 API의 응답을 처리합니다.
 * 응답에 따라 다음과 같은 동작을 수행합니다:
 * 1. 사용자 비활성화 (40301) → 403 에러 페이지로 이동
 * 2. SNS 계정 미등록 (20001) → 소셜 회원가입 페이지로 이동
 * 3. 이메일 가입 계정 존재 (20002) → 계정 통합 안내 페이지로 이동
 * 4. 정상 로그인 → 잡플로이 엑세스토큰으로 강제 로그인 및 이전 URL로 이동
 * 5. 알 수 없는 응답 → 오류 메시지 표시
 * @returns
 */
window.onLoginResult = function (jsonString) {
    return __awaiter(this, void 0, void 0, function () {
        var response, code, data, locale, query, query, token, redirectUrl, separator, finalUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    response = {};
                    try {
                        response = JSON.parse(jsonString);
                    }
                    catch (e) {
                        console.error("JSON 파싱 오류:", e);
                        alert("로그인 응답 처리 중 오류가 발생했습니다.");
                        return [2 /*return*/];
                    }
                    code = response.code;
                    data = response.data || {};
                    // 사용자 비활성화 (40301)
                    if (String(code) === '40301') {
                        window.location.replace('/error/40301');
                        return [2 /*return*/];
                    }
                    locale = document.documentElement.lang || 'ko';
                    // SNS 계정 미등록 → 소셜 회원가입 페이지로 이동
                    if (String(code) === '20001') {
                        query = new URLSearchParams({
                            provider_user_id: data.provider_user_id,
                            social_provider: data.provider,
                        });
                        window.location.replace("/".concat(locale, "/social/signup?").concat(query.toString()));
                        return [2 /*return*/];
                    }
                    // 이메일 가입 계정 존재 → 계정 통합 안내 페이지로 이동
                    if (String(code) === '20002') {
                        query = new URLSearchParams({
                            provider_user_id: data.provider_user_id,
                            social_provider: data.provider,
                            locale: document.documentElement.lang || 'ko'
                        });
                        window.location.replace("/".concat(locale, "/social/account-merge?").concat(query.toString()));
                        return [2 /*return*/];
                    }
                    if (!data.token) return [3 /*break*/, 2];
                    token = data.token;
                    ApiService.setToken(token); // 토큰 저장
                    return [4 /*yield*/, registerPushToken()];
                case 1:
                    _a.sent(); // 푸시토큰 등록
                    redirectUrl = localStorage.getItem('intendedUrl') || '/';
                    separator = redirectUrl.includes('?') ? '&' : '?';
                    finalUrl = "".concat(redirectUrl).concat(separator, "_access_token=").concat(token, "&remember=y");
                    window.location.replace(finalUrl);
                    return [2 /*return*/];
                case 2:
                    // 알 수 없는 응답
                    console.error("알 수 없는 로그인 응답:", response);
                    alert("현재 소셜 로그인 응답을 처리할 수 없습니다.");
                    return [2 /*return*/];
            }
        });
    });
};
// 파일 선택 시 이미지 미리보기 표시
document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('fileInput');
    var preview = document.getElementById('preview');
    if (input && preview) {
        input.addEventListener('change', function () {
            var _a;
            var file = (_a = input.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!file)
                return;
            var reader = new FileReader();
            reader.onload = function (e) {
                var _a;
                preview.src = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                preview.style.display = 'block';
            };
            reader.readAsDataURL(file);
        });
    }
});
